import { render, staticRenderFns } from "./LaborServiceCompany.vue?vue&type=template&id=5eb1bba4&scoped=true"
import script from "./LaborServiceCompany.vue?vue&type=script&lang=js"
export * from "./LaborServiceCompany.vue?vue&type=script&lang=js"
import style0 from "./LaborServiceCompany.vue?vue&type=style&index=0&id=5eb1bba4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb1bba4",
  null
  
)

export default component.exports